import { apiClient } from '@/shared/lib/axios';
import { getApiErrorMessage } from '@/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import useAppToast from '../useAppToast';

interface BulkCopyPayload {
  source_id: number;
  target_ids: number[];
}

export const useAdminInsurerAttentionBulkCopy = (onSuccess?: () => void) => {
  const { site } = useParams<{ site: string }>();
  const siteType = site ?? 'medix';
  const toast = useAppToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: BulkCopyPayload) =>
      apiClient.post(`/admin/${siteType}/insurer-attentions/bulk-copy`, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-insurer-attentions', siteType] });
      toast.success('コピーしました。');
      onSuccess?.();
    },
    onError: err => {
      toast.error(getApiErrorMessage(err, 'コピーに失敗しました。'));
    },
  });
};
